import React, { useState } from 'react'
import { getCities, getParams } from '../services/City'
import { useHistory } from 'react-router-dom'
import Cookies from 'js-cookie'
import Sidebar from '../components/Sidebar'
function Home() {
    const [city, setCity] = React.useState(null)
    const [cities, setCities] = React.useState(null)
    const [loading, setLoading] = React.useState(false)
    const history = useHistory()
    React.useEffect(() => {
        Cookies.set('city', JSON.stringify(1))
        getCities().then(data => {
            setCities(data);
        })
        Cookies.set('searchString', "")
    }, [cities])

    function handleLogout() {
        Cookies.remove('username')
        Cookies.remove('city')
        history.push('/login')
    }
    function handlePress() {
        setLoading(true)
        setLoading(false)
        history.push('/main')
    }
    const [hideOptions, setHideOption] = useState(true);
    const [icon, setIcon] = useState(<svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="40 151 29 29">
        <path d="M54.5 151A14.516 14.516 0 0 0 40 165.5 14.516 14.516 0 0 0 54.5 180 14.516 14.516 0 0 0 69 165.5 14.517 14.517 0 0 0 54.5 151Zm-5.065 8.53h10.058c.563 1.646.89 3.363.97 5.117H48.466c.078-1.754.407-3.471.97-5.118Zm-.97 6.823h12a18.456 18.456 0 0 1-.975 5.118H49.44a18.394 18.394 0 0 1-.975-5.118Zm10.35-8.53h-8.703a19.276 19.276 0 0 1 3.361-5.066c.34-.026.68-.051 1.027-.051a11.74 11.74 0 0 1 .84.04 89.398 89.398 0 0 0 .112.008 19.32 19.32 0 0 1 3.364 5.07Zm-8.696 15.353h8.69a19.324 19.324 0 0 1-3.376 5.07c-.309.022-.62.048-.933.048-.341 0-.674-.026-1.006-.051a19.37 19.37 0 0 1-3.375-5.067Zm12.052-6.823h5.08a12.668 12.668 0 0 1-1.444 5.118h-4.51a20.068 20.068 0 0 0 .874-5.118Zm-.87-6.824h4.506a12.722 12.722 0 0 1 1.444 5.118h-5.08a20.062 20.062 0 0 0-.87-5.118Zm-19.552 6.824h5.01a20.068 20.068 0 0 0 .875 5.118h-4.44a12.668 12.668 0 0 1-1.445-5.118Zm5.01-1.706h-5.01a12.668 12.668 0 0 1 1.444-5.118h4.436a20.062 20.062 0 0 0-.87 5.118Zm13.93 8.53h4.022a12.824 12.824 0 0 1-6.678 4.61 20.772 20.772 0 0 0 2.656-4.61Zm4.022-15.353h-4.015a20.794 20.794 0 0 0-2.644-4.606 12.827 12.827 0 0 1 6.66 4.606Zm-20.424 15.352h3.952a20.716 20.716 0 0 0 2.64 4.587 12.81 12.81 0 0 1-6.592-4.587Zm3.947-15.352h-3.947a12.824 12.824 0 0 1 6.574-4.584 20.75 20.75 0 0 0-2.627 4.584Z" fill-rule="evenodd" data-name="world-svgrepo-com" />
    </svg>)
    const [selectVal, setSelectVal] = useState('Seattle')
    const [rotate, setRotate] = useState(0);

    const optionsArr = [
        {
            value: 'Seattle',
            icon: <svg style={{ marginRight: '5%' }} xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="40 151 29 29">
                <path d="M54.5 151A14.516 14.516 0 0 0 40 165.5 14.516 14.516 0 0 0 54.5 180 14.516 14.516 0 0 0 69 165.5 14.517 14.517 0 0 0 54.5 151Zm-5.065 8.53h10.058c.563 1.646.89 3.363.97 5.117H48.466c.078-1.754.407-3.471.97-5.118Zm-.97 6.823h12a18.456 18.456 0 0 1-.975 5.118H49.44a18.394 18.394 0 0 1-.975-5.118Zm10.35-8.53h-8.703a19.276 19.276 0 0 1 3.361-5.066c.34-.026.68-.051 1.027-.051a11.74 11.74 0 0 1 .84.04 89.398 89.398 0 0 0 .112.008 19.32 19.32 0 0 1 3.364 5.07Zm-8.696 15.353h8.69a19.324 19.324 0 0 1-3.376 5.07c-.309.022-.62.048-.933.048-.341 0-.674-.026-1.006-.051a19.37 19.37 0 0 1-3.375-5.067Zm12.052-6.823h5.08a12.668 12.668 0 0 1-1.444 5.118h-4.51a20.068 20.068 0 0 0 .874-5.118Zm-.87-6.824h4.506a12.722 12.722 0 0 1 1.444 5.118h-5.08a20.062 20.062 0 0 0-.87-5.118Zm-19.552 6.824h5.01a20.068 20.068 0 0 0 .875 5.118h-4.44a12.668 12.668 0 0 1-1.445-5.118Zm5.01-1.706h-5.01a12.668 12.668 0 0 1 1.444-5.118h4.436a20.062 20.062 0 0 0-.87 5.118Zm13.93 8.53h4.022a12.824 12.824 0 0 1-6.678 4.61 20.772 20.772 0 0 0 2.656-4.61Zm4.022-15.353h-4.015a20.794 20.794 0 0 0-2.644-4.606 12.827 12.827 0 0 1 6.66 4.606Zm-20.424 15.352h3.952a20.716 20.716 0 0 0 2.64 4.587 12.81 12.81 0 0 1-6.592-4.587Zm3.947-15.352h-3.947a12.824 12.824 0 0 1 6.574-4.584 20.75 20.75 0 0 0-2.627 4.584Z" fill-rule="evenodd" data-name="world-svgrepo-com" />
            </svg>,
            classes: 'col-md-12'
        },
        {
            value: 'Portland',
            icon: <svg style={{ marginRight: '5%' }} xmlns="http://www.w3.org/2000/svg" width="29" height="34.982" viewBox="40 207.518 29 34.982">
                <path d="M43.764 227.129v1.464h4.09l2.977 13.907h1.497l-2.977-13.907h3.847V242.5H55.8v-13.907h3.847L56.671 242.5h1.496l2.977-13.907h4.09v-1.464h-21.47ZM40 222.569l1.708 2.434h25.584L69 222.57H40Zm10.482-6.512 1.179 2.359-5.53 1.382h16.737l-5.53-1.382 1.179-2.359h-8.035Zm3.285-8.54v7.076h1.464v-7.075h-1.464Z" fill-rule="evenodd" data-name="space-needle-svgrepo-com" />
            </svg>,
            classes: 'col-md-12'
        },
        {
            value: 'San Diego',
            icon: <svg style={{ marginRight: '5%' }} xmlns="http://www.w3.org/2000/svg" width="29" height="34.982" viewBox="40 207.518 29 34.982">
                <path d="M43.764 227.129v1.464h4.09l2.977 13.907h1.497l-2.977-13.907h3.847V242.5H55.8v-13.907h3.847L56.671 242.5h1.496l2.977-13.907h4.09v-1.464h-21.47ZM40 222.569l1.708 2.434h25.584L69 222.57H40Zm10.482-6.512 1.179 2.359-5.53 1.382h16.737l-5.53-1.382 1.179-2.359h-8.035Zm3.285-8.54v7.076h1.464v-7.075h-1.464Z" fill-rule="evenodd" data-name="space-needle-svgrepo-com" />
            </svg>,
            classes: 'col-md-12'
        },
        {
            value: 'Las Vegas',
            icon: <svg style={{ marginRight: '5%' }} xmlns="http://www.w3.org/2000/svg" width="29" height="34.982" viewBox="40 207.518 29 34.982">
                <path d="M43.764 227.129v1.464h4.09l2.977 13.907h1.497l-2.977-13.907h3.847V242.5H55.8v-13.907h3.847L56.671 242.5h1.496l2.977-13.907h4.09v-1.464h-21.47ZM40 222.569l1.708 2.434h25.584L69 222.57H40Zm10.482-6.512 1.179 2.359-5.53 1.382h16.737l-5.53-1.382 1.179-2.359h-8.035Zm3.285-8.54v7.076h1.464v-7.075h-1.464Z" fill-rule="evenodd" data-name="space-needle-svgrepo-com" />
            </svg>,
            classes: 'col-md-12 lastOption'
        }
    ]

    const renderOptions = optionsArr.map((option, index) => {
        if (selectVal !== option.value) {
            return (
                <div className={option.classes || index === optionsArr.length - 3 ? `${option.classes} oddOption` : option.classes} onClick={() => clickOpt(option.value, option.icon)} style={{ background: '#182b54' }}>
                    <h6>{option.icon}{option.value} <button className='btn btn-sm btn-secondary p-1' style={{ float: 'right' }}>comming soon</button></h6>
                </div>
            )
        }
    })

    const showHideOptions = () => {
        setHideOption(!hideOptions);
        if (hideOptions === true) {
            setRotate(180);
        }
        else {
            setRotate(0);
        }
    }



    const clickOpt = (value, iconFun) => {
        showHideOptions();
        setSelectVal(value)
        setIcon(iconFun)
    }
    return (

        <div id="wrapper" class="main_dashboard">

            <Sidebar main={"side-icon active"} home={"side-icon "} pass={"side-icon "} screen="Home" />

            <div id="content-wrapper" class="d-flex flex-column">

                <div id="DesktopHome">
                    <div class="show-map">
                        <div class="page-content-section">
                            <div class="map img Landbrige_map">
                                <div class="bg_content" style={{ top: "60%" }}>
                                    <div class="text-map-content">
                                        {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" style={{ color: "white" }}></span>}

                                        <h3><strong>Select City</strong> <span>you want to explore</span></h3>
                                        {/* <p>See a city you'd like to purchase access to <a href='#'>Contact Us</a></p>  */}
                                    </div>
                                    <img class="map-svg" src="assets/img/Map.svg" alt="LB-Icon-White.svg" usemap="#image-map"></img>


                                    <a onClick={handlePress} href="javascript:void(0);">
                                        <map name="image-map">
                                            <area alt="" title="Seattle" onClick={handlePress} coords="1,9,122,86" shape="rect"></area>
                                        </map>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="MobileHome " class="dispnone" >
                    <div class="show-map">
                        <div class="page-content-section">
                            <div class="map img Landbrige_map flex-box">
                                <div className="innerContent">
                                    <div className="selectBox">
                                        <h3 className='text-center'>Select City to explore properties</h3>
                                        <div className="selectCity mt-4">
                                            <div className="row">
                                                <div className="col-md-12 spaceBW" style={{ borderRadius: '5px 5px 0 0 ' }} onClick={showHideOptions}>
                                                    <h6> {icon}   {selectVal}</h6>
                                                    <span class="material-symbols-outlined" style={{ transform: `rotate(${rotate}deg)` }}></span>
                                                </div>
                                                {hideOptions || renderOptions}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="row"> */}
                                    <div className="col-md-12">
                                        <button onClick={handlePress} type="button" class="btncontine btn btn-primary" style={{ width: '100%' }}>
                                            Continue
                                        </button>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>

        </div>
    )

    {/* <div class="main-wrapper">
        <NavbarSession main={true}/>
 
          
       
       <div class="contact-us">
             
             <div class="row" >
          
             <div class="col-md-1 SideBarLayout" >
           
                             
                           
             <div class="icons">
       <img src="/assets/img/Sglobe.png"  onClick={handleSelectionCity} style={{width:"30px"}}></img>
       {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" style={{color:"white"}}></span>}
       </div>

               <div class="iconschlid">
               <img src="/assets/img/UProp.png"  onClick={handlePress} style={{width:"30px"}}></img></div> 
               <div class="icons3chlid">
       <img src="/assets/img/USet.png"   onClick={handleChanePass} style={{width:"30px"}}></img> </div>
            
            </div> 
            <div class="col-md-11 City-wrapper" usemap="#image-map">
            <img src="/assets/img/City.png" usemap="#image-map"></img>
            <map name="image-map">
              <area  alt="" title="Seattle"  onClick={handlePress} coords="389,168,512,242" shape="rect"></area>
            </map>
{/* 
            <h4>Select City you<span class="blue-text"> want to explore</span></h4>
                <form class="mt-5">
                    <div class="form-group">
                        <label> {alert &&<span style={{color: 'red'}} >Please Select City</span>}</label>
                        <select style={{background: "white" , color:"black"}} onChange={e => setCity(e.target.value)} class="form-control" >
                                    <option>Select City</option>
                                    {cities.map(item => {
                                        return (
                                            <option value={item.CityId} >{item.CityName}</option>
                                        )
                                    })}
                                </select>
                    </div>
                  

                    <div class="form-group text-right mt-4 w-100">
                        <a
                            class="btn btn-secondary"
                            onClick={handlePress}
                            >
                                {loading && <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
                                Search
                                </a>
                    </div>

                </form> }
            </div>
           
          
        </div>
        </div>
        </div> */}


}

export default Home;
